export const bookingMapDataKeys = {
	all: ['booking-map-data'] as const,
	leg: (legId: string) => ['booking-map-data', legId] as const,
};
